<main class="text-start">
    <div class=" flex justify-start gap-2 items-start">
        <h1 class="page-title md:my-2! text-black">{{ 'products.title' | translate }}</h1>
        <p class="bg-[#0768F7] rounded-full text-white px-2 py-1 text-xs hidden sm:block">{{ productsResponse?.count }}</p>
    </div>

    <div class="w-full bg-[#F6F6F6] rounded-lg p-3.5 flex justify-start cursor-pointer" [routerLink]="['/products/new']">
        <div
            class="w-96 bg-white flex justify-start gap-5 rounded-xl px-5 py-5 items-center border-s-2 border-t-2 border-dashed border-[#FFDB43]">
            <div class="bg-[#FFFDE4] w-[50px] h-[50px] flex justify-center items-center rounded-[1.2rem]">
                <i class="bi bi-folder-plus text-2xl text-[#FFDB43]"></i>
            </div>
            <div>
                <p class="text-[#4B4B4B] text-sm font-medium">{{ 'products.add_new' | translate }}</p>
            </div>
        </div>
    </div>
    <div class="w-full bg-[#F6F6F6] rounded-lg mt-10 p-3.5">

        <div class="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div class="border border-[#e0e0e0] w-full sm:w-72 rounded-lg overflow-hidden flex">
                <span class="bg-white py-[7.5px] ps-2.5">
                    <i class="bi bi-search text-sm"></i>
                </span>
                <input type="text"
                    class="bg-white py-[8px] px-4 w-full text-start focus:outline-none focus:border-black text-xs"
                    [placeholder]="'products.search_placeholder' | translate" (input)="onSearchChange($event)">
            </div>
            <div class="max-sm:w-full flex max-sm:justify-start gap-2">
                <app-filters-dropdown
                    [filters]="productFilters"
                    [ngModel]="filterValues"
                    (ngModelChange)="onFiltersChange($event)"
                    [lang]="languageService.currentLang()"
                />
                <button app-export-excel-button class="ms-3 hidden sm:inline-flex"
                    [disabled]="isExporting"
                    (click)="onExportExcel()"></button>
            </div>
        </div>

        <app-filtering-chips [options]="statusFilters" (onFilter)="onFilter($event)" />

        <div class="overflow-x-auto">
            <table class="generic-table mt-2.5">
                <thead>
                    <tr>
                        <th>{{ 'products.table.image' | translate }}</th>
                        <th>{{ 'products.table.name' | translate }}</th>
                        <th>{{ 'products.table.category' | translate }}</th>
                        <th>{{ 'products.table.rating' | translate }}</th>
                        <th>{{ 'products.table.status' | translate }}</th>
                        <th>{{ 'products.table.price' | translate }}</th>
                        <th>{{ 'products.table.action' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!productsResponse">
                        <tr *ngFor="let _ of [1,2,3,4,5]" app-table-skeleton-row [columns]="7"></tr>
                    </ng-container>
                    <tr *ngFor="let product of productsResponse?.results">
                        <td class="flex justify-start items-center">
                            <img [src]="product.cover_image" class="w-13 h-10 rounded object-cover" alt="">
                        </td>
                        <td>{{ languageService.currentLang() === 'ar' ? product.name_ar : (product.name_en || product.name_ar) }}</td>
                        <td>{{ product.subcategory.name }}</td>
                        <td> {{ product.reviews_summary?.avg_rating ?? 0 }} {{ product.reviews_summary?.reviews_count ?
                            `(${product.reviews_summary?.reviews_count})` : '' }} <i
                                class="bi bi-star-fill text-[#FACA15]"></i> </td>
                        <td>
                            <span [ngClass]="{
                                        'bg-green-100 text-green-800': product.status == 'active',
                                        'bg-yellow-100 text-yellow-800': product.status == 'inactive',
                                        'bg-red-100 text-red-800': product.status == 'deleted',
                                        }" class="status-chip">
                                {{ 'products.status.' + product.status | translate }}
                            </span>
                        </td>
                        <td>
                            <div class="flex gap-2 justify-start">
                                <p>{{ product.default_variant ? product.default_variant.price : '?' }}</p>
                                <p>{{ 'common.currency' | translate }}</p>
                            </div>
                        </td>
                        <td>
                            <button
                                class="bg-white border border-gray-200 px-3 py-1.5 rounded-lg text-xs cursor-pointer"
                                [routerLink]="['/products', product.id]">{{ 'products.actions.details' | translate }}</button>
                        </td>
                    </tr>
                    <tr *ngIf="productsResponse?.count == 0" class="cursor-pointer">
                        <td colspan="100%">{{ 'products.no_products' | translate }}</td>
                    </tr>
                </tbody>
            </table>

        </div>
        <!-- Pagination -->
        <app-table-pagination *ngIf="productsResponse" [count]="productsResponse.count" [limit]="pagination.limit" [offset]="pagination.offset"
            (pageChange)="updatePagination($event)" />
    </div>
</main>
